import styled from 'styled-components';

export const HistoryCard = styled.div`
  display: flex;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.neutral_300};
`;

export const TextWrapper = styled.div`
  width: max-content;
  display: flex;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
`;

export const PrintButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${({ theme }) => theme.primary_300};
  background-color: transparent;
  text-decoration: underline;
  cursor: pointer;

  .icon {
    display: flex;
  }

  &:hover {
    opacity: 0.7;
  }
`;
